import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDisrootComponent } from './simple-icons-disroot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDisrootComponent ],
    exports:      [ SimpleIconsDisrootComponent ],
    bootstrap:    []
})
export class SimpleIconsDisrootModule {}
